import { cn } from '@/lib/utils';
import type { EventSource } from '@/types/fleet';

// Values pinned to the API's vps_events.source enum.
const SOURCE_STYLES: Record<EventSource, string> = {
  'admin-ui': 'bg-indigo-100 text-indigo-800',
  semaphore: 'bg-orange-100 text-orange-800',
  prometheus: 'bg-red-100 text-red-800',
  autoscaler: 'bg-cyan-100 text-cyan-800',
  'git-sync': 'bg-emerald-100 text-emerald-800',
};

export function EventSourceBadge({
  source,
  className,
}: {
  source: string;
  className?: string;
}): JSX.Element {
  const style = SOURCE_STYLES[source as EventSource] ?? 'bg-slate-100 text-slate-700';

  return (
    <span
      className={cn(
        'inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium',
        style,
        className,
      )}
    >
      {source}
    </span>
  );
}
